<template>
  <text-subpage page-type="termsOfUse" class="brussels-content" />
</template>

<script>
import Vue from 'vue'
import TextSubpage from '~brand-components/brussels/shared/text-subpage.vue'

export default Vue.extend({
  components: {
    TextSubpage,
  },
})
</script>

<style lang="scss">
.brussels-content {
  .content-block {
    p {
      @apply mb-3;
    }

    ul {
      @apply pl-5 mb-3;

      li {
        @apply list-disc;
      }
    }

    a {
      @apply text-sn-secondary;
    }
  }
}
</style>
